import {connect} from "react-redux";
import NotAtSiteAttendance from "./NotAtSiteAttendance";
import {bindActionCreators} from "redux";
import { documentUploadUrlPublic } from "../../service/fileUpload/action";
import { markCheckIn, getTheAttendanceDetails, markCheckOut } from "../../service/DarwinAttendance/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    insertNonSiteAttendance: state.DarwinAttendanceSync.insertNonSiteAttendance,
    attendanceDetails: state.DarwinAttendanceSync.attendanceDetails,
    nonSiteCheckout: state.DarwinAttendanceSync.nonSiteCheckout
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            markCheckIn,
            getTheAttendanceDetails,
            markCheckOut
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(NotAtSiteAttendance);
